module.exports = __webpack_public_path__ + "img/石林4_1.df1f936e.jpg";